import React, { useState } from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { useForm } from "react-hook-form";
import Inputs from "../../share/input/Inputs";
import { BtnPrimary } from "../../share/buttons/Btn";
import { Modal } from "../../share/modal/Modal";
import Selectedroleaccess from "./Selectedroleaccess";

function NewRollModal({ close }) {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => console.log(data);
  const [showRoll, setShowRoll] = useState(false);
  return (
    <div className="AddnewsupportTicket relative">
      <button
        onClick={() => close(false)}
        className="AddnewsupportTicket-cancel absolute  "
      >
        <div>
          <Cancel />
        </div>
      </button>
      <h3 className=" text-[#77498F] font-bold text-[2rem] leading-[3.2rem] text-center">
        افزودن دسترسی جدید
      </h3>
      <form onSubmit={handleSubmit(onSubmit)} className="mt-[5rem]">
        <Inputs
          register={{
            required: {
              value: true,
              message: "Enter Name",
            },
          }}
          type="text"
          name="name"
          control={control}
          placeholder="نام *"
          className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem]"
        />
        <Inputs
          register={{
            required: {
              value: true,
              message: "Enter Name",
            },
          }}
          type="text"
          name="name"
          control={control}
          placeholder="شماره تماس *"
          className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem]"
        />
        <div>
          <p className=" text-[#212121E5] font-normal text-[1.8rem] leading-[3.2rem] mb-[0.5rem]">
            دسترسی مورد نظر:
          </p>
          <div className=" flex flex-row items-center justify-between mt-[1.2rem]">
            <div className=" flex items-center justify-start ml-[5rem]">
              <label
                htmlFor="weak"
                className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
              >
                <input
                  {...register("course", { required: true })}
                  type="radio"
                  name="course"
                  value="weak"
                  className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                  id="weak"
                />{" "}
                استاد
              </label>
            </div>
            <div className=" flex items-center justify-start ml-[5rem]">
              <label
                htmlFor="منتور"
                className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
              >
                <input
                  {...register("course", { required: true })}
                  type="radio"
                  name="course"
                  value="منتور"
                  className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                  id="منتور"
                />{" "}
                منتور
              </label>
            </div>
            <div className=" flex items-center justify-start ml-[5rem]">
              <label
                htmlFor="مربی"
                className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
              >
                <input
                  {...register("course", { required: true })}
                  type="radio"
                  name="course"
                  value="مربی"
                  className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                  id="مربی"
                />{" "}
                مربی
              </label>
            </div>
            <div className=" flex items-center justify-start ">
              <label
                htmlFor="داور"
                className=" text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center"
              >
                <input
                  {...register("course", { required: true })}
                  type="radio"
                  name="course"
                  value="داور"
                  className="form-check-input PriceForm radio-lg ml-[0.8rem]"
                  id="داور"
                />{" "}
                داور
              </label>
            </div>
          </div>
        </div>
        <p
          className=" text-[#77498F] leading-[2.4rem] text-[1.6rem] font-normal mt-[1.8rem] cursor-pointer"
          onClick={() => setShowRoll(true)}
        >
          مشاهده دسترسی های سمت انتخابی{" "}
        </p>
        <div className=" text-left mt-[2.8rem]">
          <BtnPrimary text="ثبت" className="px-16 py-7" />
        </div>
      </form>
      <Modal show={showRoll}>
        <Selectedroleaccess close={setShowRoll} />
      </Modal>
    </div>
  );
}

export default NewRollModal;
